module Meevo.Plugins.Client {
    "use strict";
    export class ImageGallerySection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ClientImageGallery> {

        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected contextParams: Meevo.ContextParamsService,
            protected modalService: Components.Modal.IModalService,
            imageGalleryService: Meevo.Components.Common.IImageGalleryService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            this.isInteropContext = true;
        }

        selected() {
            super.selected();
            this.contextParams.addInteropParams({ id: 'interop:client', isInterop: true, targetRoute: `client/${this.getParentItemId()}/image-gallery` });
        }

    }
}